import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import moment from 'moment';

import { CustomDatePickerControlComponent } from '../custom-date-picker-control/custom-date-picker-control.component';
import { ICustomCellEditorParams } from '../models/custom-date-picker.params';

@Component({
  selector: 'lib-custom-date-picker',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomDatePickerControlComponent,
  ],
  templateUrl: './custom-date-picker.component.html',
  styleUrls: ['./custom-date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomDatePickerComponent implements ICellEditorAngularComp {
  private readonly datePickerControl =
    viewChild<CustomDatePickerControlComponent>('datePickerControl');

  private params?: ICustomCellEditorParams;

  public readonly control = new FormControl<string | null>(null);

  public cellWidth = 0;
  public cellHeight = 0;

  public minDate: moment.Moment | null = null;
  public maxDate: moment.Moment | null = null;

  public agInit(params: ICustomCellEditorParams): void {
    this.params = params;

    this.control.setValue(params.value ?? null, {
      emitEvent: false,
    });

    this.minDate = params.minDate ? moment(params.minDate) : null;
    this.maxDate = params.maxDate ? moment(params.maxDate) : null;

    const cell = params.eGridCell;

    this.cellWidth = cell.clientWidth + 2;
    this.cellHeight = cell.clientHeight + 2;
  }

  public afterGuiAttached(): void {
    queueMicrotask(() => {
      this.datePickerControl()?.focus();
    });
  }

  public getValue(): string | null {
    return this.control.value;
  }

  public isPopup(): boolean {
    return true;
  }

  public onDateSelected(): void {
    this.params?.api.stopEditing();
  }
}
